/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/MvvmStructure/Service/SolitaireStarClubService',[
		'lodash',
		'pixi',
		'jszip',
		'jsziputils',
		'absolute/debug',
		'absolute/storagemanager',
		'absolute/asyncqueue',
		'Solitaire/StarClub/SCCollectionGroup',
		'Solitaire/StarClub/SCCollection',
		'Solitaire/MvvmStructure/Service/ManifestService',
		'Managers/StatManager'
	],
	function (_, PIXI, JSZip, JSZipUtils, Debug, StorageManager, AsyncQueue, SCCollectionGroup, SCCollection, ManifestService, StatManager) {
		"use strict";

		var SolitaireStarClubService = {

			_worldsCache: null,

			_worldsKey: "StarClubWorlds",

			_isValid: true,

			currentPack: null,

			currentCollection: null,

			Initialize: function (onSuccess, onError) {
				this.GetStarClubCollections(onSuccess, onError);
			},

			IsValid: function () {
				return ManifestService.IsValid();
			},

			LoadJSON: function (url, onSuccess, onError) {
				var loader = new PIXI.JsonLoader(url, true /* cross origin */);

				function onLoaded(event) {
					loader.removeEventListener('loaded', onLoaded);
					loader.removeEventListener('error', onError);
					onSuccess(loader.json);
				}

				function onError(event) {
					loader.removeEventListener('loaded', onLoaded);
					loader.removeEventListener('error', onError);
					onError(loader.json);
				}

				loader.addEventListener('loaded', onLoaded);
				loader.addEventListener('error', onError);

				loader.load();
			},

			LoadStarClubCollectionsFromCDN: function (onSuccess, onError) {
				var worldsSettings = ManifestService.GetSettings("StarClub", "Worlds");

				if (!worldsSettings) {
					onError();
					return;
				}

				var url = worldsSettings.Path;
				JSZipUtils.getBinaryContent(url, function(err, data) {
					if (err) {
						onError(err);
						return;
					}

					try {
						JSZip.loadAsync(data).then(
							function(zip) {
								zip.file("Worlds/Worlds.js").async("string").then(
									function(content) {
										var worlds = JSON.parse(content);

										var collections = worlds.PMWorldsListList.concat(worlds.PacksV2);
										var collectionGroupMap = {};

										collections.filter(function(c) {
											return c !== undefined && c !== null &&
											c.Theme === 'classic' && c.Name !== 'Classic';
										}).forEach(function(c) {
											// SettingsManager.getSetting('theme', 'selected');
										});

										_.forEach(worlds.CollectionGroupPriorityTable, function(collectionGroup) {
											collectionGroupMap[collectionGroup.CollectionGroupName] 
											= new SCCollectionGroup(collectionGroup.CollectionGroupName, collectionGroup.CollectionGroupPriority)
										}, this);

										this.LoadAllCollectionIcons(zip, collections, collectionGroupMap,
											function(newCollectionsGroupMap) {
												collectionGroupMap = newCollectionsGroupMap;

												this.collectionGroups = [];
												_.forEach(collectionGroupMap, function(collectionGroup) {
													collectionGroup.sort();
													this.collectionGroups.push(collectionGroup);
												}, this);

												this.collectionGroups = [];
												_.forEach(collectionGroupMap, function(collectionGroup) {
													collectionGroup.sort();
													this.collectionGroups.push(collectionGroup);
												}, this);

												this.collectionGroups.sort(function(a, b) {
													return b.Priority - a.Priority;
												});

												this.LoadCollectionPacks(
													function() {
														onSuccess(data);
													}.bind(this), onError
												);

											}.bind(this),
											function(e) {
												onError(e);
											}.bind(this)
										);

									}.bind(this)
								);
						}.bind(this));

					} catch (e) {
						onError(e);
					}
				}.bind(this));
			},

			LoadAllCollectionIcons: function(zip, collections, collectionGroupMap, resolve, reject) {
				
				var totalImagesLoaded = 0;

				_.forEach(collections, function(collectionConfig) {
					try {
						zip.file("Worlds/" + collectionConfig.ImgPath).async("base64").then(
						function(data64) {
							var imageUrl = "data:image/png;base64," + data64;
							var icon = PIXI.Texture.fromImage(imageUrl, false, PIXI.scaleModes.LINEAR);
							var collection = new SCCollection(collectionConfig, icon);

							if (collectionGroupMap[collection.CollectionGroupName]) {
								collectionGroupMap[collection.CollectionGroupName].addCollection(collection);
							}
						}).then(function() {
							totalImagesLoaded++;
							
							// Calls completion function when every image has been loaded
							if (totalImagesLoaded == collections.length) {
								resolve(collectionGroupMap);
							}
						}).catch(function(e) {
							console.error("Error in catch for decoding images");
							console.error(e);
						});

					} catch (err) {
						totalImagesLoaded++;
						console.error("Error while decoding file: " + "Worlds/" + collectionConfig.ImgPath + " from zip, proceeding anyways and pack will not display.");
						console.error(err);
						reject(err);
					}
				});
			},

			LoadCollectionPacks: function (onSuccess, onError) {

				var loadQueue = new AsyncQueue();

				_.forEach(this.collectionGroups, function (collectionGroup) {
					_.forEach(collectionGroup.Collections, function (collection) {

						loadQueue.pushTask(function (p, c) {
							this.LoadPacksToCollection(collection, p, c);
						}.bind(this));
					}, this);

				}, this);

				loadQueue.run(
					function (pc) {
						Debug.log("Load packs progress " + Math.round(pc * 100));
					},
					function () {
						onSuccess();
					});
			},

			LoadPacksToCollection: function (collection, onProgress, onComplete) {

				var key = collection.Key;
				if (key) {
					var settings = ManifestService.GetSettings("StarClub", key);
					if (!settings) {
						console.error("StarClub settings not found in Manifest");
						return;
					}

					var url = settings.Path;
					if (!url) {
						console.error("Path not found in Star Club settings in Manifest");
						return;
					}

					JSZipUtils.getBinaryContent(url, function(err, data) {
						if (err) {
							console.error("Error retrieving zip from URL");
							return;
						}

						JSZip.loadAsync(data).then(
							function(zip) {
								this.ApplyCollectionProperties(zip, collection, 
									function(newCollection) {
										collection = newCollection;
										collection.buildPacks();
										onComplete();
									}.bind(this),
									function(e) {
										console.error(e);
									}
								);
							}.bind(this)
						)
						.catch(function(e) {
							console.error("Error loading received zip as folder");
							console.error(e);
						}.bind(this));
					}.bind(this));
				}
			},

			ApplyCollectionProperties: function(zip, collection, resolve, reject) {
				
				var total = _.size(zip.files);
				var count = 0;

				_.forEach(zip.files, function(file) {
					try {
						if (file.name.indexOf(".js") != -1) {
							zip.file(file.name).async("string").then(
								function(content) {
									var config = JSON.parse(content);
									collection.setPackConfig(config);
								}
							).then(function() {
								count++;
								if (count === total) {
									resolve(collection);
								}
							})
						} else if (file.name.indexOf(".png") != -1) {
							zip.file(file.name).async("base64").then(
								function(data64) {
									var imageUrl = "data:image/png;base64," + data64;
									var image = PIXI.Texture.fromImage(imageUrl, false, PIXI.scaleModes.LINEAR);
									collection.addImage(file.name.substring(collection.Key.length + 1), image);
								}
							).then(function() {
								count++;
								// Calls completion function when every file has been checked
								if (count === total) {
									resolve(collection);
								}
							})
						}
						else if (file.name.indexOf("/", file.name.length - "/".length) !== -1) {
							// Checks if file is a parent subdirectory, which has no use
							count++;
						}
					} catch (err) {
						console.error("Error while decoding file: " + file.name);
						reject(err);
					}
				});
			},

			GetStarClubCollections: function (onSuccess, onError) {

				var worldsData = null;
				/*
							if (this._worldsCache) {
								worldsData = this._worldsCache;
							}
							else {
								worldsData = this._worldsCache = StorageManager.fetch(this._worldsKey);
							}*/

				if (worldsData) {
					setTimeout(function () {
						onSuccess(worldsData)
					}, 0);
				}
				else {
					this.LoadStarClubCollectionsFromCDN(
						function (response) {
							StorageManager.store(this._worldsKey, response);
							this._worldsCache = response;
							onSuccess(response);
						}.bind(this),
						function (message) {
							this._isValid = false;
							onError(message)
						}.bind(this));
				}
			},


			GetStarClubGlobalStats: function () {
				var totalStats = {
					totalStarsEarned: 0,
					challengesCompleted: 0,
					totalChallenges: 0,
					packsUnlocked: 0,
					collectionsUnlocked: 0,
					crownsEarned: 0,
					collectionsCompleted: 0,
					collectionsTotal: 0
				};

				_.forEach(this.CollectionGroups, function (collectionGroup) {
					var stats = collectionGroup.getCollectionGroupStats();
					totalStats.totalStarsEarned += stats.totalStarsEarned;
					totalStats.challengesCompleted += stats.challengesCompleted;
					totalStats.totalChallenges += stats.totalChallenges;
					totalStats.packsUnlocked += stats.packsUnlocked;
					totalStats.collectionsUnlocked += stats.collectionsUnlocked;
					totalStats.crownsEarned += stats.crownsEarned;
					totalStats.collectionsCompleted += stats.collectionsCompleted;
					totalStats.collectionsTotal += stats.collectionsTotal;

				}, this);

				return totalStats;
			},

			UpdateGlobalStarClubStats: function () {
				if (!this._worldsCache) {
					return;
				}
				var globalStats = this.GetStarClubGlobalStats();
				StatManager.SetStatistic("SCGlobalStarsEarned", globalStats.totalStarsEarned);
				StatManager.SetStatistic("SCGlobalChallengesCompleted", globalStats.challengesCompleted);
				StatManager.SetStatistic("SCGlobalPacksUnlocked", globalStats.packsUnlocked);
				StatManager.SetStatistic("SCGlobalCollectionsUnlocked", globalStats.collectionsUnlocked);
				StatManager.SetStatistic("SCGlobalCrownsEarned", globalStats.crownsEarned);
				StatManager.SetStatistic("SCGlobalTotalChallenges", globalStats.totalChallenges);
				StatManager.SetStatistic("SCGlobalTotalCollections", globalStats.collectionsTotal);
				StatManager.SetStatistic("SCGlobalTotalCollectionsCompleted", globalStats.collectionsCompleted);

				StatManager.Save();
			}
		};

		Object.defineProperty(SolitaireStarClubService, "CollectionGroups", {
			get: function () {
				return this.collectionGroups;
			}
		});


		return SolitaireStarClubService;
	});

/*
 https://download-ssl.msgamestudios.com/content/mgs/ce/production/4D530A3D/world20130504040512.zip/2/world20130504040512.zip
 https://download-ssl.msgamestudios.com/content/mgs/ce/production/4D530A3D/worldGameKlondike.zip/2/worldGameKlondike.zip
 https://download-ssl.msgamestudios.com/content/mgs/ce/production/4D530A3D/worldGameFreecell.zip/1/worldGameFreecell.zip
 https://download-ssl.msgamestudios.com/content/mgs/ce/production/4D530A3/world20145309115320.zip/1/world20145309115320.zip
 https://download-ssl.msgamestudios.com/content/mgs/ce/production/4D530A3D/Worlds.zip/10/Worlds.zip
 */
;
